// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".admin-container[data-v-72ac7e30]{display:flex;justify-content:center;padding:40px}.admin-container.mobile[data-v-72ac7e30]{margin-top:1rem;padding:40px 0}.admin-container.mobile .menu[data-v-72ac7e30]{position:absolute;top:0;right:10px}.admin-container .menu[data-v-72ac7e30]{position:absolute;top:20px;right:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
